import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from 'src/AppContext';
import { User } from 'src/viewModels/User';
import { GetUserDetailsInput, GetUserDetailsPayload } from './generated/types';
import { ModuleId } from './mappers/module';

export interface UserDetails {
    groups: Map<string, string>;
    user: Pick<User, 'email' | 'firstName' | 'lastName' | 'role' | 'id' | 'assignedModuleIds'>;
}

const query = `query GetUserDetails($input: GetUserDetailsInput!) {
    getUserDetails (input: $input) {
        groups {
            id
            name
        }
        user {
            email
            firstName
            lastName
            role
            id
            moduleIds
        }
      }
  }`;

export const useGetUserDetails = (userId: string | undefined) => {
    const context = useContext(AppContext);

    const input: GetUserDetailsInput = {
        targetUserId: userId!,
    };

    return useQuery({
        queryKey: ['getUserDetails', userId],
        queryFn: async (): Promise<UserDetails> => {

            const response = await (context.api.graphql({ query, variables: { input } }) as Promise<{
                data: {
                    getUserDetails: GetUserDetailsPayload;
                };
            }>);

            const { user, groups } = response.data.getUserDetails;

            const result = {
                user: {
                    email: user.email,
                    firstName: user.firstName ?? '',
                    lastName: user.lastName ?? '',
                    role: user.role,
                    id: user.id,
                    assignedModuleIds: user.moduleIds.map(id => id as ModuleId),
                },
                groups: new Map(groups.map(({ name, id }) => ([id, name]))),
            };

            return result;

        },
        enabled: !!userId,
        refetchOnWindowFocus: false,
    });
};
